import {PuiRadioItem} from "@portnet/ui";
import React from "react";

const AppRadioItem = React.forwardRef((props, ref) => (
  <PuiRadioItem ref={ref} {...props} />
));

export default AppRadioItem;
